import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import {
    Table, TableBody, TableCell, TableHead, TableRow, Tooltip, withStyles,
} from '@material-ui/core';
import {
    Button, Col, DatePicker, Icon, Input, Row, Tag,
} from 'antd';
import Moment from 'react-moment';
import MomentJS from 'moment';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { table_styles } from '../../../../components/TableStyles';
import TablePaginationActions from '../../../../components/pagination/TablePaginationActions';
import EnhancedTableToolbar from '../../../../components/table_toolbar/table_toolbar';
import {
    getManagerLeadsRequest, setManagerLeadManageKey, setManagerLeadManagePagination, updateManagerLeadManageKey,
} from '../redux/actions/get_manager_leads.actions';
import { leadManagerChangeLeadsStatusRequest } from '../redux/actions/lead_manager_lead_status.actions';
import { get, getVal } from '../../../../shared/helpers';

const { RangePicker } = DatePicker;


class ManagerLeadsTable extends Component {
    constructor(props) {
        super(props);
        this.updateManagerSpecial = this.updateManagerSpecial.bind(this);
        this.killManagerSpecial = this.killManagerSpecial.bind(this);
        this.dateChangeHandler = this.dateChangeHandler.bind(this);
        this.setMargin = this.setMargin.bind(this);
        this.updateData = this.updateData.bind(this);
        this.filterMargin = this.filterMargin.bind(this);
        this.resetMargin = this.resetMargin.bind(this);
        this.setLocation = this.setLocation.bind(this);
        this.filterCounty = this.filterCounty.bind(this);
        this.addCheckbox = this.addCheckbox.bind(this);
        this.bulkUpdateManagerSpecial = this.bulkUpdateManagerSpecial.bind(this);
        this.bulkKillManagerSpecial = this.bulkKillManagerSpecial.bind(this);

        this.state = {
            dateFrom: undefined,
            dateTo: undefined,
            marginFrom: '',
            marginTo: '',
            location: '',
            leadList: [],
        };
    }

    updateData = () => {
        this.props.getManagerLeadsRequest(this.props.filters, this.props.pagination);
    };

    componentDidMount() {
        this.updateData();
    }

    bulkUpdateManagerSpecial(e) {
        e.preventDefault();

        const list = this.state.leadList;

        if (list.length > 0) {
            list.map(function (b, j) {
                this.props.leadManagerChangeLeadsStatusRequest(b.id, false, b.margin);
                this.wait(1000);

                if (list.length === (j + 1)) {
                    this.setState({ leadList: [] });
                    this.updateData();
                }
            }, this);
        }
    }

    bulkKillManagerSpecial(e) {
        e.preventDefault();

        const list = this.state.leadList;

        if (list.length > 0) {
            list.map(function (b, j) {
                this.props.leadManagerChangeLeadsStatusRequest(b.id, true, b.margin);
                this.wait(1000);

                if (list.length === (j + 1)) {
                    this.setState({ leadList: [] });
                    this.updateData();
                }
            }, this);
        }
    }

    changePage = (event, page) => {
        if (event) {
            this.props.setManagerLeadManagePagination('pagination', { page });
        }
    };

    handleChangeRowsPerPage = (event) => {
        if (event) {
            const rpp = event.target.value;
            this.props.setManagerLeadManagePagination('pagination', { page: 0, rows_per_page: rpp });
        }
    };

    wait = (ms) => {
        const start = new Date().getTime();
        let end = start;
        while (end < start + ms) {
            end = new Date().getTime();
        }
    };

    updateManagerSpecial(e) {
        e.preventDefault();
        const leadId = e.target.getAttribute('data-id');
        const margin = e.target.getAttribute('data-margin');

        this.props.leadManagerChangeLeadsStatusRequest(leadId, false, margin);

        this.wait(2000);
        this.updateData();
        // window.location.reload();
    }

    killManagerSpecial(e) {
        e.preventDefault();
        const leadId = e.target.getAttribute('data-id');
        const margin = e.target.getAttribute('data-margin');

        this.props.leadManagerChangeLeadsStatusRequest(leadId, true, margin);

        this.wait(2000);
        this.updateData();
        // window.location.reload();
    }

    dateChangeHandler = (e) => {
        if (e && e.length !== 0) {
            this.props.setManagerLeadManageKey('filters', { dateFrom: e[0], dateTo: e[1] });
            this.updateData();
        } else {
            this.props.setManagerLeadManageKey('filters', { dateFrom: undefined, dateTo: undefined });
            this.updateData();
        }
    };

    setMargin(e) {
        e.preventDefault();
        const { state } = this;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    setLocation(e) {
        e.preventDefault();
        const { state } = this;
        state.location = e.target.value;
        this.setState(state);
    }

    filterCounty(e) {
        e.preventDefault();

        if (this.state.location && this.state.location !== '') {
            this.props.setManagerLeadManageKey('filters', { location: this.state.location });
            this.updateData();
        }
    }

    filterMargin(e) {
        e.preventDefault();

        if (this.state.marginFrom && this.state.marginFrom !== '' && this.state.marginTo && this.state.marginTo !== '') {
            this.props.setManagerLeadManageKey('filters', { marginFrom: this.state.marginFrom, marginTo: this.state.marginTo });
            this.updateData();
        }
    }

    resetMargin(e) {
        e.preventDefault();
        this.setState({
            marginFrom: undefined, marginTo: undefined, location: undefined, dateFrom: undefined, dateTo: undefined,
        });
        this.props.setManagerLeadManageKey('filters', {
            marginFrom: undefined, marginTo: undefined, location: undefined, dateFrom: undefined, dateTo: undefined,
        });
        this.updateData();
    }

    addCheckbox(e) {
        const leadId = e.target.getAttribute('data-id');
        const margin = e.target.getAttribute('data-margin');

        let { leadList } = this.state;

        if (leadList.length === 0) {
            leadList = [];
            leadList.push({ id: leadId, margin });
            this.setState({ leadList });
        } else {
            const exists = leadList.filter(e => e.id === leadId);

            if (exists.length > 0) {
                let i = 0;
                leadList.map(function (l, j) {
                    if (l.id === leadId) {
                        leadList.splice(i, 1);
                    }
                    i += 1;

                    if (leadList.length === (j + 1)) {
                        this.setState({ leadList });
                    }
                }, this);
            } else {
                leadList.push({ id: leadId, margin });
                this.setState({ leadList });
            }
        }
    }

    compare(a, b) {
        if (a.customer_valuation && b.customer_valuation) {
            if (a.valuations[a.valuations.length - 1] && b.valuations[b.valuations.length - 1]) {
                const bandA = parseFloat(a.customer_valuation) - parseFloat(a.valuations[a.valuations.length - 1].valuation);
                const bandB = parseFloat(b.customer_valuation) - parseFloat(b.valuations[b.valuations.length - 1].valuation);

                let comparison = 0;
                if (bandA > bandB) {
                    comparison = 1;
                } else if (bandA < bandB) {
                    comparison = -1;
                }
                return comparison;
            }

            return -1;
        }

        return -1;
    }

    render() {
        const { classes: { root1, tableWrapper, table }, leads, lead_profile_access } = this.props;
        const titles = [
            { content: 'VRM', width: '5%', align: 'left' },
            { content: 'Bike', align: 'left' },
            { content: 'Year', width: '4%', align: 'right' },
            { content: 'Mileage', width: '5%', align: 'right' },
            { content: 'CC', width: '4%', align: 'right' },
            { content: 'Retail Price', width: '8%', align: 'right' },
            { content: 'Cust. Valuation', width: '8%', align: 'right' },
            { content: 'Valuation', width: '8%', align: 'right' },
            { content: 'Cus. Wants Diff', width: '10%', align: 'right' },
            { content: 'New Margin', width: '10%', align: 'right' },
            { content: 'Status', width: '8%', align: 'right' },
            { content: 'Location', width: '8%', align: 'right' },
            { content: 'Stock', width: '4%', align: 'right' },
            { content: 'PL', width: '4%', align: 'right' },
            { content: 'Action', width: '12%', align: 'center' },
        ];

        const compareDate = new MomentJS().subtract(5, 'minutes');

        return (
            <div className={root1} style={{ marginTop: 0, borderRadius: 0 }}>

                <Row>
                    <Col span={24} style={{ position: 'relative' }}>
                        <Input type="tel" name="marginFrom" onChange={this.setMargin} value={this.state.marginFrom} placeholder="From Net Margin" style={{ display: 'inline', marginRight: 10, width: 150 }} />
                        <Input type="tel" name="marginTo" onChange={this.setMargin} value={this.state.marginTo} placeholder="To Net Margin" style={{ display: 'inline', width: 150, marginRight: 10 }} />
                        <a
                            href="#"
                            onClick={this.filterMargin}
                            style={{
                                backgroundColor: '#1890ff', color: '#fff', borderRadius: '5px', marginRight: 20, padding: '6px 10px',
                            }}
                        >
                            Go
                        </a>
                        <RangePicker
                            style={{ width: 270, margin: '0 10px 0 0' }}
                            onChange={this.dateChangeHandler}
                            defaultValue={this.state.dateFrom && [moment(this.state.dateFrom), moment(this.state.dateTo)]}
                        />
                        <Input type="tel" name="location" onChange={this.setLocation} value={this.state.location} placeholder="County" style={{ display: 'inline', marginRight: 10, width: 250 }} />
                        <a
                            href="#"
                            onClick={this.filterCounty}
                            style={{
                                backgroundColor: '#1890ff', color: '#fff', borderRadius: '5px', marginRight: 10, padding: '6px 10px',
                            }}
                        >
                            Go
                        </a>
                        <a
                            href="#"
                            onClick={this.resetMargin}
                            style={{
                                backgroundColor: '#CCCCCC', color: '#fff', borderRadius: '5px', marginRight: 10, padding: '6px 10px', float: 'right',
                            }}
                        >
                            Reset Search
                        </a>

                    </Col>

                </Row>

                <EnhancedTableToolbar
                    displayDataList={Array(this.props.leadsCount)}
                    rowsPerPageOptions={[100, 250, 500]}
                    updateData={this.updateData}
                    rowsPerPage={this.props.pagination.rows_per_page}
                    page={this.props.pagination.page}
                    onChangePage={this.changePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    TablePaginationActionsWrapped={TablePaginationActions}
                />

                <div className={tableWrapper}>
                    <Table className={table}>
                        <TableHead>
                            <TableRow>
                                {
                                    titles.map((title, index) => (
                                        <TableCell
                                            key={index}
                                            style={{
                                                width: [title.width],
                                                padding: '0 5px',
                                                textAlign: [title.align],
                                                fontSize: '12px',
                                            }}
                                        >
                                            {title.content}
                                        </TableCell>
                                    ))
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                !this.props.loading && this.props.leads && leads.sort(this.compare).map((lead, index) => {
                                    const date = new MomentJS(lead.created_date);

                                    let email = get(lead, 'ref_lead_customer.full_name');

                                    if (email === null || email === undefined) {
                                        email = '';
                                    }

                                    if (date.isBefore(compareDate) || email.includes('superbikefactory.co.uk')) {
                                        return (
                                            <TableRow key={lead._id}>
                                                <TableCell style={{ padding: '0 5px', fontSize: '12px' }}>
                                                    <Link
                                                        to={!lead_profile_access ? { pathname: `/Leads/Lead_profile/${lead._id}` } : { pathname: '' }}
                                                        style={{ color: 'black' }}
                                                    >
                                                        <span style={{ whiteSpace: 'nowrap' }}>
                                                            {
                                                                lead.ref_bike_lead
                                                                    ? lead.ref_bike_lead.vrm
                                                                        ? lead.ref_bike_lead.vrm.toUpperCase()
                                                                        : '-'
                                                                    : '-'
                                                            }
                                                        </span>
                                                    </Link>
                                                </TableCell>
                                                <TableCell style={{ padding: '0  5px', fontSize: '12px' }}>
                                                    <Link
                                                        to={!lead_profile_access ? { pathname: `/Leads/Lead_profile/${lead._id}` } : { pathname: '' }}
                                                        style={{ color: 'black' }}
                                                    >
                                                        {
                                                            (lead.ref_bike_lead && lead.ref_bike_lead.ref_bike_brand && lead.ref_bike_lead.ref_bike_model)
                                                                ? <span>{`${lead.ref_bike_lead.ref_bike_brand.name} ${lead.ref_bike_lead.ref_bike_model.name} ${lead.ref_bike_lead.ref_bike_model.model_variation || ''}`}</span>
                                                                : (lead.ref_bike_lead && lead.ref_bike_lead.ref_bike_brand && lead.ref_bike_lead.unmaped_data && Object.keys(lead.ref_bike_lead.unmaped_data).length !== 1)
                                                                    ? <span>{`${lead.ref_bike_lead.ref_bike_brand.name} ${lead.ref_bike_lead.unmaped_data.bike_model}`}</span>
                                                                    : (lead.ref_bike_lead && lead.ref_bike_lead.ref_bike_brand)
                                                                        ? <span>{`${lead.ref_bike_lead.ref_bike_brand.name}`}</span>
                                                                        : (
                                                                            <span style={{
                                                                                fontStyle: 'italic',
                                                                                color: 'lightgray',
                                                                            }}
                                                                            >
                                                                                Unknown
                                                                            </span>
                                                                        )
                                                        }
                                                        {
                                                            getVal(lead, 'ref_bike_lead.ref_bike_model.name')
                                                        && (
                                                            <Icon
                                                                type="tag"
                                                                theme="twoTone"
                                                                twoToneColor="#28a745"
                                                                style={{ margin: 7 }}
                                                            />
                                                        )
                                                        }
                                                        {
                                                            lead.is_duplicate
                                                        && <small><Tag color="#f50" className="tag">Dupe</Tag></small>
                                                        }
                                                        {
                                                            lead.is_part_complete
                                                        && <small><Tag color="volcano" className="tag">Part complete</Tag></small>
                                                        }
                                                        {
                                                            lead.deleted_date
                                                        && (
                                                            <small>
                                                                <Tag
                                                                    color="#cc0000"
                                                                    className="tag"
                                                                >
                                                                    Deleted
                                                                </Tag>
                                                            </small>
                                                        )
                                                        }
                                                        {
                                                            lead.part_ex && lead.part_ex.is_part_ex
                                                        && (
                                                            <small>
                                                                <Tag color="volcano" className="tag">
                                                                    Part
                                                                    Ex
                                                                </Tag>
                                                            </small>
                                                        )
                                                        }

                                                        {lead.has_completed_blemish && (
                                                            <small>
                                                                <Tag
                                                                    color="#cc0000"
                                                                    className="tag"
                                                                >
                                                                    Blemish
                                                                    {' '}
                                                                    {lead.completed_blemish_step === 'step-1' ? '25%' : lead.completed_blemish_step === 'step-2' ? '50%' : lead.completed_blemish_step === 'step-3' ? '75%' : lead.completed_blemish_step === 'step-4' ? '100%' : ''}
                                                                </Tag>
                                                            </small>
                                                        )}
                                                        {(lead.photos && lead.photos.length > 0)
                                                    && (
                                                        <small style={{ marginLeft: 5 }}>
                                                            {lead.photos.length}
                                                            {' '}
                                                            photos
                                                        </small>
                                                    )}

                                                    </Link>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'right', padding: '0 5px', fontSize: '12px' }}>
                                                    <span>
                                                        {
                                                            lead.ref_bike_lead && lead.ref_bike_lead.ref_bike_variant
                                                                ? lead.ref_bike_lead.ref_bike_variant.year
                                                                : lead.ref_bike_lead && lead.ref_bike_lead.unmaped_data && lead.ref_bike_lead.unmaped_data.bike_year
                                                                    ? lead.ref_bike_lead.unmaped_data.bike_year
                                                                    : '-'
                                                        }
                                                    </span>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'right', padding: '0 5px', fontSize: '12px' }}>
                                                    <span>
                                                        {
                                                            lead.ref_bike_lead
                                                                ? lead.ref_bike_lead.mileage
                                                                : ''
                                                        }
                                                    </span>
                                                </TableCell>
                                                <TableCell style={{
                                                    width: 100,
                                                    textAlign: 'right',
                                                    padding: '0 5px',
                                                    fontSize: '12px',
                                                }}
                                                >
                                                    <span>
                                                        {
                                                            lead.ref_bike_lead && lead.ref_bike_lead.ref_bike_model
                                                                ? lead.ref_bike_lead.ref_bike_model.cc
                                                                : lead.ref_bike_lead && lead.ref_bike_lead.unmaped_data && lead.ref_bike_lead.unmaped_data.bike_cc
                                                                    ? lead.ref_bike_lead.unmaped_data.bike_cc
                                                                    : '-'
                                                        }
                                                    </span>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'right', padding: '0 5px', fontSize: '12px' }}>
                                                    {
                                                        (lead.valuations && lead.valuations.length)
                                                            ? (
                                                                <span>
                                                                    &pound;
                                                                    {lead.valuations[lead.valuations.length - 1].retail_price}
                                                                </span>
                                                            )
                                                            : <span>-</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'right', padding: '0 5px', fontSize: '12px' }}>
                                                    <span>
                                                        &pound;
                                                        {lead.customer_valuation}
                                                    </span>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'right', padding: '0 5px', fontSize: '12px' }}>
                                                    {
                                                        (lead.valuations && lead.valuations.length)
                                                            ? (
                                                                <span>
                                                                    &pound;
                                                                    {lead.valuations[lead.valuations.length - 1].valuation}
                                                                </span>
                                                            )
                                                            : <span>-</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'right', padding: '0 5px', fontSize: '12px' }}>
                                                    {
                                                        (lead.valuations && lead.valuations.length)
                                                            ? (
                                                                <span>
                                                                    &pound;
                                                                    {parseFloat(lead.customer_valuation) - parseFloat(lead.valuations[lead.valuations.length - 1].valuation)}
                                                                </span>
                                                            )
                                                            : <span>-</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'right', padding: '0 5px', fontSize: '12px' }}>
                                                    {
                                                        (lead.valuations && lead.valuations.length)
                                                            ? (
                                                                <span>
                                                                    &pound;
                                                                    {lead.valuations[lead.valuations.length - 1].retail_price - lead.customer_valuation}
                                                                </span>
                                                            )
                                                            : <span>-</span>
                                                    }
                                                </TableCell>

                                                <TableCell style={{ textAlign: 'right', padding: '0 5px', fontSize: '12px' }}>
                                                    <span>
                                                        {
                                                            lead.ref_lead_status
                                                                ? lead.ref_lead_status.name
                                                                : '-'
                                                        }
                                                    </span>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'right', padding: '0 5px', fontSize: '12px' }}>
                                                    <span>{get(lead, 'ref_lead_customer.address.county.name') || '-'}</span>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'right', padding: '0 5px', fontSize: '12px' }}>
                                                    <span>
                                                        {
                                                            lead.ref_bike_lead && lead.ref_bike_lead.ref_bike_variant
                                                                ? lead.ref_bike_lead.ref_bike_variant.current_stock_count
                                                                : '-'
                                                        }

                                                    </span>
                                                </TableCell>
                                                <TableCell style={{ textAlign: 'right', padding: '0 5px', fontSize: '12px' }}>
                                                    <span>
                                                        {
                                                            lead.ref_bike_lead && lead.ref_bike_lead.ref_bike_variant
                                                                ? lead.ref_bike_lead.ref_bike_variant.par_level
                                                                : '-'
                                                        }

                                                    </span>
                                                </TableCell>
                                                <TableCell
                                                    style={{ padding: '0 5px', fontSize: '12px', textAlign: 'center' }}
                                                >
                                                    <Button className="ant-btn ant-btn-primary" size="small" data-id={lead._id} data-margin={(lead.valuations && lead.valuations.length) ? lead.valuations[lead.valuations.length - 1].retail_price - lead.valuations[lead.valuations.length - 1].valuation : 0} onClick={this.updateManagerSpecial} style={{ marginRight: 5 }}>Add</Button>
                                                    <Button className="ant-btn ant-btn-danger" size="small" data-id={lead._id} data-margin={(lead.valuations && lead.valuations.length) ? lead.valuations[lead.valuations.length - 1].retail_price - lead.valuations[lead.valuations.length - 1].valuation : 0} onClick={this.killManagerSpecial} style={{ marginRight: 5 }}>Kill</Button>
                                                    <input type="checkbox" data-id={lead._id} data-margin={(lead.valuations && lead.valuations.length) ? lead.valuations[lead.valuations.length - 1].retail_price - lead.valuations[lead.valuations.length - 1].valuation : 0} onChange={this.addCheckbox} />
                                                </TableCell>


                                            </TableRow>
                                        );
                                    }
                                })
                            }
                            {this.state.leadList.length > 0
                            && (
                                <TableRow>
                                    <TableCell colSpan={14} />
                                    <TableCell colSpan={1}>
                                        <Button
                                            className="ant-btn ant-btn-primary"
                                            size="small"
                                            onClick={this.bulkUpdateManagerSpecial}
                                            style={{ marginRight: 5 }}
                                        >
                                            Add
                                        </Button>
                                        <Button
                                            className="ant-btn ant-btn-danger"
                                            size="small"
                                            onClick={this.bulkKillManagerSpecial}
                                            style={{ marginRight: 5 }}
                                        >
                                            Kill
                                        </Button>

                                    </TableCell>
                                </TableRow>
                            )
                            }
                            {
                                !this.props.loading && this.props.leadsCount === 0
                                && (
                                    <TableRow>
                                        <TableCell colSpan={titles.length}>Unfortunately no leads match this search criteria</TableCell>
                                    </TableRow>
                                )
                            }
                            {
                                this.props.loading && this.props.leadsCount === 0
                                && (
                                    <TableRow>
                                        <TableCell colSpan={titles.length}>Loading Manager Special leads</TableCell>
                                    </TableRow>
                                )
                            }

                        </TableBody>
                    </Table>
                </div>

                <EnhancedTableToolbar
                    displayDataList={Array(this.props.leadsCount)}
                    rowsPerPageOptions={[100, 250, 500]}
                    updateData={this.updateData}
                    rowsPerPage={this.props.pagination.rows_per_page}
                    page={this.props.pagination.page}
                    onChangePage={this.changePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    TablePaginationActionsWrapped={TablePaginationActions}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    pagination: state.ManagerLeads.Manager_leads_manage.pagination,
    leads: state.ManagerLeads.Manager_leads_manage.manager_leads,
    loading: state.ManagerLeads.Manager_leads_manage.loading,
    leadsCount: state.ManagerLeads.Manager_leads_manage.manager_leads_count,
    current_user: state.App.App_content.user,

});


export default connect(mapStateToProps, {
    leadManagerChangeLeadsStatusRequest,
    getManagerLeadsRequest,
    setManagerLeadManageKey,
    updateManagerLeadManageKey,
    setManagerLeadManagePagination,
})(withStyles(table_styles)(ManagerLeadsTable));

/*

 */



// WEBPACK FOOTER //
// ./src/modules/Leads/Manager_special/components/ManageLeadsTable.js